// extracted by mini-css-extract-plugin
module.exports = {"root":"Toggle_root__ZlEra","title":"Toggle_title__i1IG6","switcher":"Toggle_switcher__qLlhZ"};